import { MethodCommands, MethodHandler, MethodProperties } from '@lentau/analytics/health-metrics/shared';

import { promoactionSearchHandler } from './action-detail-methods-handlers';
import { MethodPropertiesKey } from '../../shared/consts';

export enum ActionDetailsMethods {
  PromoactionSearch = 'promoactionSearch',
}

export const ACTION_DETAIL_HANDLER_LIST: MethodHandler = {
  [ActionDetailsMethods.PromoactionSearch]: promoactionSearchHandler,
};

export const ACTION_DETAIL_PROPERTIES_LIST: MethodProperties = new Map([
  [
    ActionDetailsMethods.PromoactionSearch,
    [
      {
        key: MethodPropertiesKey.TEAM,
        value: MethodCommands.SE,
      },
    ],
  ],
]);
